@if (package()) {
    <div class="flex justify-center">
        <div
            [style.background-color]="package()?.package_color"
            [style.color]="package()?.package_text_color"
            class="text-label-medium flex max-w-36 min-w-24 items-center justify-center gap-2 rounded-xl px-2 py-1.5"
        >
            <svg-icon [svgStyle]="{ width: '12px', height: '12px' }" src="assets/icons/Rating-Star.svg" />
            <p class="text-label-medium">{{ prefix() }} {{ package()?.translations_refs | getTranslation: "title" }}</p>
        </div>
    </div>
}
